/**
 * 订单表格工厂组件
 * 根据订单类型返回对应的表格组件
 */
import React from 'react'
import MaternityCenterOrderTable from './MaternityCenterOrderTable'
import TraditionalMedicineOrderTable from './TraditionalMedicineOrderTable'
import DentalOrderTable from './DentalOrderTable'
import HomeServiceOrderTable from './HomeServiceOrderTable'

const OrderTableFactory = (props) => {
  const { orderType, ...restProps } = props
  // 根据订单类型返回对应的表格组件
  switch (orderType) {
    case 'maternity_center':
      return <MaternityCenterOrderTable {...restProps} />
    case 'traditional_medicine':
      return <TraditionalMedicineOrderTable {...restProps} />
    case 'dental':
      return <DentalOrderTable {...restProps} />
    case 'home_service':
      return <HomeServiceOrderTable {...restProps} />
    default:
      return <MaternityCenterOrderTable {...restProps} />
  }
}

export default OrderTableFactory
